<span class="status-chip" [ngClass]="chipClass">

  {{ status }}

</span>